import { render } from "./DeletedUserListContent.vue?vue&type=template&id=6d9a6620"
import script from "./DeletedUserListContent.vue?vue&type=script&lang=js"
export * from "./DeletedUserListContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__